import { useSalonContext } from '@customer/components/pages/Salon/context'
import UnexpectedSalonTypeError from '@errors/UnexpectedSalonTypeError'
import React from 'react'
import SalonCurrentParticipation from './components/CurrentParticipation'
import SalonEmptyParticipation from './components/EmptyParticipation/SalonEmptyParticipation'
import SalonPastParticipation from './components/PastParticipation/SalonPastParticipation'
import SalonVotingParticipation from './components/VotingParticipation/SalonVotingParticipation'

export default function SalonParticipationByType({ position, participation }: Props) {
    const { salon } = useSalonContext()

    switch (salon.state.type) {
        case 'current':
            if (!participation)
                return <SalonEmptyParticipation position={position} />
                
            return <SalonCurrentParticipation participation={participation} />
        case 'voting':
            if (!participation)
                return null

            return <SalonVotingParticipation participation={participation as Customer.Resources.Participation} />
        case 'finished':
            if (!participation)
                return null
                
            return <SalonPastParticipation participation={participation as Customer.Resources.PastParticipation} />
        default:
            throw new UnexpectedSalonTypeError(salon.state.type)
    }
}

interface Props {
    position: string
    participation: Customer.Resources.Participation | Customer.Resources.PastParticipation | null
}